import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

/**
 * ConfirmationPopup Component
 */
class ConfirmationPopup extends React.Component {
  /**
   * Constructor
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      modal: true
    };
  }

  onAcceptPopup = () => {
    this.setModal(this.state.modal);
    this.props.onAccept({ confirmType: this.props.confirmType });
  };

  onRejectPopup = () => {
    this.setModal(this.state.modal);
    this.props.onReject({ confirmType: this.props.confirmType });
  };

  /**
   * setModal
   * @param val
   */
  setModal = (val) => {
    this.setState({ modal: !val });
  };

  /**
   * Render function
   * @returns {Modal}
   */
  render() {
    const { content } = this.props;
    return (
      <div>
        <Modal isOpen={this.state.modal} toggle={this.onReject}>
          <ModalBody>{content}</ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.onAcceptPopup}>
              Ok
            </Button>
            <Button color="secondary" onClick={this.onRejectPopup}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

/**
 * defaultProps
 * @type {{content: string}}
 */
ConfirmationPopup.propTypes = {
  content: PropTypes.string.isRequired,
  onAccept: PropTypes.func.isRequired,
  onReject: PropTypes.func
};

ConfirmationPopup.defaultProps = {
  onReject: () => {}
};

/**
 * ConfirmationPopup
 */
export default ConfirmationPopup;
